import { useAdminGuard } from "@/hooks/useAdminGuard";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { AdminStats } from "@/components/admin/AdminStats";
import { UsersTable } from "@/components/admin/UsersTable";
import { Loader2, ShieldX } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate, useLocation } from "react-router-dom";

export default function Admin() {
  const { isAdmin, loading } = useAdminGuard();
  const navigate = useNavigate();
  const location = useLocation();

  const isUsersPage = location.pathname === "/admin/users";

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div className="min-h-screen bg-background flex flex-col items-center justify-center gap-4 p-4">
        <ShieldX className="h-16 w-16 text-destructive" />
        <h1 className="text-2xl font-bold text-center">Acesso Negado</h1>
        <p className="text-muted-foreground text-center">
          Você não tem permissão para acessar esta área.
        </p>
        <Button onClick={() => navigate("/")}>Voltar ao início</Button>
      </div>
    );
  }

  return (
    <AdminLayout>
      {isUsersPage ? (
        <div className="space-y-4">
          <div>
            <h1 className="text-2xl md:text-3xl font-bold">Usuários</h1>
            <p className="text-muted-foreground">
              Gerenciar todos os usuários do sistema
            </p>
          </div>
          <UsersTable />
        </div>
      ) : (
        <div className="space-y-6">
          <div>
            <h1 className="text-2xl md:text-3xl font-bold">Dashboard</h1>
            <p className="text-muted-foreground">
              Visão geral do VerdeIA
            </p>
          </div>
          <AdminStats />
          <div className="space-y-4">
            <h2 className="text-xl font-semibold">Usuários</h2>
            <UsersTable />
          </div>
        </div>
      )}
    </AdminLayout>
  );
}
